module.exports = __webpack_public_path__ + "img/unexpected-moments.58af89c1.jpg";